<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove invoice {{hefc.hefc_nr}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHefc">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hefc_encrid: null,
      hefc: {}
    }
  },
  methods: {
    open(hefc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/eign/hefc/getHefcTmp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHefcTmp"
          },
          getHefcTmp: {
            hefc_encrid: hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hefc = res.data.getHefcTmp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHefc() { 
      this.$axios
        .post("ares/json/ares/eign/hefc/rmHefc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHefc"
          },
          rmHefc: {
            hefc_encrid: this.hefc.hefc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
            setTimeout(() => { opener.location.reload(); window.close(); }, 2000);
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHefc.text,
              color: res.data.rmHefc.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

